import jApi from './jApi';

export default {
  listCategory(module) {
    const api = jApi.generateApi();
    return api.get(`kurikulum/document/category/list/${module}`)
      .then(res => res);
  },

  listPegawai() {
    const api = jApi.generateApi();
    return api.get('pegawai/list')
      .then(res => res);
  },

  listKelas() {
    const api = jApi.generateApi();
    return api.get('kelas/list')
      .then(res => res);
  },

  listSiswa() {
    const api = jApi.generateApi();
    return api.get('siswa/list')
      .then(res => res);
  },

  getListDokumenSaya(req) {
    const api = jApi.generateApi();
    return api.post('kurikulum/document/mention/list', req)
      .then(res => res);
  },

  getListSemuaLaporan(req) {
    const api = jApi.generateApi();
    return api.post('kurikulum/document/list-all', req)
      .then(res => res);
  },

  // Admin Pembelajaran -----------------------------------
  // Requester
  getListAdminPembelajaran(req) {
    const api = jApi.generateApi();
    return api.post('kurikulum/document/list', req)
      .then(res => res);
  },

  createAdminPembelajaran(req) {
    const api = jApi.generateApi();
    return api.post('kurikulum/document/create', req)
      .then(res => res);
  },

  updateAdminPembelajaran(req) {
    const api = jApi.generateApi();
    return api.post('kurikulum/document/update', req)
      .then(res => res);
  },

  submitAdminPembelajaran(req) {
    const api = jApi.generateApi();
    return api.post('kurikulum/document/submit', req)
      .then(res => res);
  },

  deleteAdminPembelajaran(req) {
    const api = jApi.generateApi();
    return api.post('kurikulum/document/delete', req)
      .then(res => res);
  },

  detailAdminPembelajaran(req) {
    const api = jApi.generateApi();
    return api.post('kurikulum/document/detail', req)
      .then(res => res);
  },

  getListAdminPembelajaranReport(req) {
    const api = jApi.generateApi();
    return api.post('kurikulum/document/list-all ', req)
      .then(res => res);
  },

  // Approver
  getListAdminPembelajaranApp(req) {
    const api = jApi.generateApi();
    return api.post('kurikulum/document/approver/list', req)
      .then(res => res.data);
  },

  approveAdminPembelajaranApp(req) {
    const api = jApi.generateApi();
    return api.post('kurikulum/document/approver/approve', req)
      .then(res => res);
  },

  rejectAdminPembelajaranApp(req) {
    const api = jApi.generateApi();
    return api.post('kurikulum/document/approver/reject', req)
      .then(res => res);
  },

  // Additional Info
  getAdditionalInfo(req) {
    const api = jApi.generateApi();
    return api.get(`kurikulum/document/category/additional-info/list/${req}`)
      .then(res => res);
  },

  // Kepegawaian -----------------------------------
  createPegawai(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/create', req)
      .then(res => res);
  },

  updatePegawai(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/update', req)
      .then(res => res);
  },

  detailPegawai(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail', req)
      .then(res => res);
  },

  deletePegawai(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/delete', req)
      .then(res => res);
  },

  changePasswdPegawai(req) {
    const api = jApi.generateApi();
    return api.post('user/change-password', req)
      .then(res => res);
  },

  // Sertifikasi
  getListSertifikasi(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/sertifikasi/list', req)
      .then(res => res);
  },

  createSertifikasi(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/sertifikasi/create', req)
      .then(res => res);
  },

  updateSertifikasi(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/sertifikasi/update', req)
      .then(res => res);
  },

  deleteSertifikasi(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/sertifikasi/delete', req)
      .then(res => res);
  },

  // Pendidikan
  getListPendidikan(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/pendidikan-formal/list', req)
      .then(res => res);
  },

  createPendidikan(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/pendidikan-formal/create', req)
      .then(res => res);
  },

  updatePendidikan(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/pendidikan-formal/update', req)
      .then(res => res);
  },

  deletePendidikan(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/pendidikan-formal/delete', req)
      .then(res => res);
  },

  // Kompetensi
  getListKompetensi(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/kompetensi/list', req)
      .then(res => res);
  },

  createKompetensi(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/kompetensi/create', req)
      .then(res => res);
  },

  updateKompetensi(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/kompetensi/update', req)
      .then(res => res);
  },

  deleteKompetensi(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/kompetensi/delete', req)
      .then(res => res);
  },

  // Anak
  getListAnak(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/anak/list', req)
      .then(res => res);
  },

  createAnak(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/anak/create', req)
      .then(res => res);
  },

  updateAnak(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/anak/update', req)
      .then(res => res);
  },

  deleteAnak(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/anak/delete', req)
      .then(res => res);
  },

  // Buku
  getListBuku(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/buku/list', req)
      .then(res => res);
  },

  createBuku(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/buku/create', req)
      .then(res => res);
  },

  updateBuku(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/buku/update', req)
      .then(res => res);
  },

  deleteBuku(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/buku/delete', req)
      .then(res => res);
  },

  // Diklat
  getListDiklat(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/diklat/list', req)
      .then(res => res);
  },

  createDiklat(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/diklat/create', req)
      .then(res => res);
  },

  updateDiklat(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/diklat/update', req)
      .then(res => res);
  },

  deleteDiklat(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/diklat/delete', req)
      .then(res => res);
  },

  // Karya Tulis
  getListKaryaTulis(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/karya-tulis/list', req)
      .then(res => res);
  },

  createKaryaTulis(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/karya-tulis/create', req)
      .then(res => res);
  },

  updateKaryaTulis(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/karya-tulis/update', req)
      .then(res => res);
  },

  deleteKaryaTulis(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/karya-tulis/delete', req)
      .then(res => res);
  },

  // Beasiswa
  getListBeasiswa(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/beasiswa/list', req)
      .then(res => res);
  },

  createBeasiswa(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/beasiswa/create', req)
      .then(res => res);
  },

  updateBeasiswa(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/beasiswa/update', req)
      .then(res => res);
  },

  deleteBeasiswa(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/beasiswa/delete', req)
      .then(res => res);
  },

  // Tunjangan
  getListTunjangan(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/tunjangan/list', req)
      .then(res => res);
  },

  createTunjangan(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/tunjangan/create', req)
      .then(res => res);
  },

  updateTunjangan(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/tunjangan/update', req)
      .then(res => res);
  },

  deleteTunjangan(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/tunjangan/delete', req)
      .then(res => res);
  },

  // Kesejahteraan
  getListKesejahteraan(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/kesejahteraan/list', req)
      .then(res => res);
  },

  createKesejahteraan(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/kesejahteraan/create', req)
      .then(res => res);
  },

  updateKesejahteraan(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/kesejahteraan/update', req)
      .then(res => res);
  },

  deleteKesejahteraan(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/kesejahteraan/delete', req)
      .then(res => res);
  },

  // Tugas Tambahan
  getListTugasTambahan(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/tugas-tambahan/list', req)
      .then(res => res);
  },

  createTugasTambahan(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/tugas-tambahan/create', req)
      .then(res => res);
  },

  updateTugasTambahan(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/tugas-tambahan/update', req)
      .then(res => res);
  },

  deleteTugasTambahan(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/tugas-tambahan/delete', req)
      .then(res => res);
  },

  // Inpassing NON PNS
  getListInpassing(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/inpassing-non-pns/list', req)
      .then(res => res);
  },

  createInpassing(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/inpassing-non-pns/create', req)
      .then(res => res);
  },

  updateInpassing(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/inpassing-non-pns/update', req)
      .then(res => res);
  },

  deleteInpassing(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/inpassing-non-pns/delete', req)
      .then(res => res);
  },

  // Penghargaan
  getListPenghargaan(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/penghargaan/list', req)
      .then(res => res);
  },

  createPenghargaan(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/penghargaan/create', req)
      .then(res => res);
  },

  updatePenghargaan(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/penghargaan/update', req)
      .then(res => res);
  },

  deletePenghargaan(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/penghargaan/delete', req)
      .then(res => res);
  },

  // Nilai Tes
  getListNilaiTes(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/nilai-tes/list', req)
      .then(res => res);
  },

  createNilaiTes(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/nilai-tes/create', req)
      .then(res => res);
  },

  updateNilaiTes(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/nilai-tes/update', req)
      .then(res => res);
  },

  deleteNilaiTes(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/nilai-tes/delete', req)
      .then(res => res);
  },

  // Gaji Berkala
  getListGajiBerkala(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/gaji-berkala/list', req)
      .then(res => res);
  },

  createGajiBerkala(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/gaji-berkala/create', req)
      .then(res => res);
  },

  updateGajiBerkala(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/gaji-berkala/update', req)
      .then(res => res);
  },

  deleteGajiBerkala(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/gaji-berkala/delete', req)
      .then(res => res);
  },

  // Jabatan Pendidik
  getListJabatanPendidik(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/jabatan-pendidik/list', req)
      .then(res => res);
  },

  createJabatanPendidik(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/jabatan-pendidik/create', req)
      .then(res => res);
  },

  updateJabatanPendidik(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/jabatan-pendidik/update', req)
      .then(res => res);
  },

  deleteJabatanPendidik(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/jabatan-pendidik/delete', req)
      .then(res => res);
  },

  // Golongan
  getListGolongan(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/kepangkatan/list', req)
      .then(res => res);
  },

  createGolongan(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/kepangkatan/create', req)
      .then(res => res);
  },

  updateGolongan(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/kepangkatan/update', req)
      .then(res => res);
  },

  deleteGolongan(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/kepangkatan/delete', req)
      .then(res => res);
  },

  // Jabatan Fungsional
  getListJabatanFungsional(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/jabatan-fungsional/list', req)
      .then(res => res);
  },

  createJabatanFungsional(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/jabatan-fungsional/create', req)
      .then(res => res);
  },

  updateJabatanFungsional(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/jabatan-fungsional/update', req)
      .then(res => res);
  },

  deleteJabatanFungsional(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/jabatan-fungsional/delete', req)
      .then(res => res);
  },

  // Karir Guru
  getListKarirGuru(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/karir-pendidik/list', req)
      .then(res => res);
  },

  createKarirGuru(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/karir-pendidik/create', req)
      .then(res => res);
  },

  updateKarirGuru(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/karir-pendidik/update', req)
      .then(res => res);
  },

  deleteKarirGuru(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/riwayat/karir-pendidik/delete', req)
      .then(res => res);
  },

  // Role
  getRole(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/roles/list', req)
      .then(res => res.data);
  },

  updateRole(req) {
    const api = jApi.generateApi();
    return api.post('pegawai/detail/roles/update', req)
      .then(res => res);
  },

  // Riwayat Gaji Berkala
  checkNotification() {
    const api = jApi.generateApi();
    return api.get('pegawai/detail/riwayat/gaji-berkala/check-notification')
      .then(res => res);
  },

  // Get Prodi
  listProdi() {
    const api = jApi.generateApi();
    return api.get('prodi/list')
      .then(res => res);
  },

  // GET LOG
  getLog(req) {
    const api = jApi.generateApi();
    return api.post('kurikulum/document/log-process', req)
      .then(res => res);
  },

  // Report
  getTotalPegawaiByStatus() {
    const api = jApi.generateApi();
    return api.get('report/pegawai/total-by-status')
      .then(res => res);
  },

  getTotalPegawaiByPendidikan() {
    const api = jApi.generateApi();
    return api.get('report/pegawai/total-by-education')
      .then(res => res);
  },

  getTotalSiswa() {
    const api = jApi.generateApi();
    return api.get('report/siswa/total')
      .then(res => res);
  },

  getTotalLulusan() {
    const api = jApi.generateApi();
    return api.get('report/lulusan/total')
      .then(res => res);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiKurikulum.js